import gql from 'graphql-tag';

export const CODE_FRAGMENT = gql`
  fragment code on Coding {
    coding {
      system
      code
      display
    }
    text
  }
`;

export const IDENTIFIER_FRAGMENT = gql`
  fragment identifier on Identifier {
    system
    value
    use
  }
`;

export const VISIT_TYPES = gql`
  fragment visits on CodingFHIR {
    display
    code
  }
`;
export const QUANTITY_FRAGMENT = gql`
  fragment quantity on Quantity {
    value
    code
    unit
  }
`;

export const OBSERVATION_VALUE_FRAGMENT = gql`
  fragment observationValue on Value {
    valueQuantity {
      ...quantity
    }
    valueCodeableConcept {
      ...code
    }
    valueString
    valueBoolean
  }
  ${CODE_FRAGMENT}
  ${QUANTITY_FRAGMENT}
`;

export const EOB_COST_FRAGMENT = gql`
  fragment cost on ClaimCost {
    patientAmount
    paymentByMedicare
    patientShareBreakdown {
      institutionalCost
      pharmacyCost
      professionalCost
      visionCost
      hhaCost
      dmeCost
      oralCost
    }
  }
`;

export const EOB_SERVICE_FRAGMENT = gql`
  fragment serviceList on Service {
    date
    display
    quantity {
      value
      unit
      code
    }
    cost {
      ...cost
    }
  }
  ${EOB_COST_FRAGMENT}
`;
